export const ALLOW_STATEMENT = 'AllowStatement'
export const ASSIGNMENT_EXPRESSION = 'AssignmentExpression'
export const BINARY_EXPRESSION = 'BinaryExpression'
export const BLOCK_STATEMENT = 'BlockStatement'
export const CALL_EXPRESSION = 'CallExpression'
export const COMMENT = 'Comment'
export const COMPUTED_MEMBER_EXPRESSION = 'ComputedMemberExpression'
export const CONDITIONAL_EXPRESSION = 'ConditionalExpression'
export const ENTRY = 'Entry'
export const EXPRESSION_STATEMENT = 'ExpressionStatement'
export const FUNCTION_DECLARATION = 'FunctionDeclaration'
export const IDENTIFIER = 'Identifier'
export const IF_STATEMENT = 'IfStatement'
export const KEYWORD = 'Keyword'
export const LET_DECLARATION = 'LetDeclaration'
export const LIST_EXPRESSION = 'ListExpression'
export const LITERAL = 'Literal'
export const MAP_EXPRESSION = 'MapExpression'
export const MATCH_STATEMENT = 'MatchStatement'
export const OPERATOR = 'Operator'
export const PARENTHESES_EXPRESSION = 'ParenthesesExpression'
export const PATH_EXPRESSION = 'PathExpression'
export const PATH_PART_EXPRESSION = 'PathPartExpression'
export const PATH_PART_VARIABLE = 'PathPartVariable'
export const PATH_PART_WORD = 'PathPartWord'
export const PROGRAM = 'Program'
export const RANGE = 'Range'
export const RETURN_STATEMENT = 'ReturnStatement'
export const SERVICE_STATEMENT = 'ServiceStatement'
export const STATIC_MEMBER_EXPRESSION = 'StaticMemberExpression'
export const UNARY_EXPRESSION = 'UnaryExpression'
export const WHITESPACE = 'Whitespace'
export const WORD = 'Word'
